import clsx from 'clsx';
import React from 'react';
import useViewSettings from '../../../preload/pages/CategoryPage/Providers/ViewSettingsProvider';
import { Tab, TabsWrapper } from '../../../styled/Tabs/wrappers';

const ProductImageFilter = () => {
  const { showContextualImage, enableContextualImage, disableContextualImage } = useViewSettings();

  return (
    <TabsWrapper>
      <Tab
        className={clsx(showContextualImage && 'active')}
        disabled={showContextualImage}
        onClick={enableContextualImage}>
        Miljö
      </Tab>
      <Tab
        className={clsx(!showContextualImage && 'active')}
        onClick={disableContextualImage}
        disabled={!showContextualImage}>
        Produkt
      </Tab>
    </TabsWrapper>
  );
};

export default ProductImageFilter;
